const META_PIXEL_ID =
  process.env.REACT_APP_META_PIXEL_ID || "1937434397136392";

export const getMetaPixelId = () => META_PIXEL_ID;

export const getFacebookCookies = () => {
  const cookies = document.cookie.split(";").reduce((acc, part) => {
    const [key, value] = part.trim().split("=");
    if (key) {
      acc[key] = decodeURIComponent(value || "");
    }
    return acc;
  }, {});

  return {
    fbp: cookies._fbp || undefined,
    fbc: cookies._fbc || undefined,
  };
};

export const trackMeta = (eventName, params = {}, eventId) => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }

  if (eventId) {
    window.fbq("track", eventName, params, { eventID: eventId });
    return;
  }

  window.fbq("track", eventName, params);
};

export const initMetaAdvancedMatching = (user) => {
  if (typeof window === "undefined" || typeof window.fbq !== "function" || !user) {
    return;
  }

  const userData = {};
  if (user.email) userData.em = user.email;
  if (user.firstName) userData.fn = user.firstName;
  if (user.lastName) userData.ln = user.lastName;
  if (user.phoneNumber) userData.ph = user.phoneNumber;
  if (user.id) userData.external_id = user.id;

  if (Object.keys(userData).length === 0) {
    return;
  }

  window.fbq("init", META_PIXEL_ID, userData);
};

export const getMetaAttributionPayload = () => {
  const { fbp, fbc } = getFacebookCookies();
  return {
    fbp,
    fbc,
    eventSourceUrl: typeof window !== "undefined" ? window.location.href : undefined,
  };
};
